import { useMutation } from '@tanstack/react-query';

import { TemplateInstance } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { createTemplateInstance } from '../../requests/createTemplateInstance';
import { CreateTemplateInstancePayload } from '../../types/CreateTemplateInstancePayload';

export const useCreateTemplateInstance = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    TemplateInstance | undefined,
    Error,
    CreateTemplateInstancePayload
  >({
    mutationFn: (data) =>
      createTemplateInstance(constructPost, data).then(
        (response) => response?.data,
      ),
  });

  return { createTemplateInstance: mutateAsync, ...rest };
};
